import { QueryClientScope } from "../types";
import { setCustomerSetting } from "./setCustomerSetting";
import { CustomerSettingsKey, SetCustomerSettingsResponse } from "./types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFeatureToggle } from "src/api/featureToggling/useGetFeatureToggle";
import { FeatureToggleKey } from "src/api";

export const useSetCustomerSetting = () => {
  const queryClient = useQueryClient();
  const { data: logsDetailedFeature} = useFeatureToggle(FeatureToggleKey.LogsDetailed);
  return useMutation<SetCustomerSettingsResponse, Error, { key: CustomerSettingsKey; value: string | boolean }>({
    mutationFn: ({ key, value }) => setCustomerSetting(key, value, logsDetailedFeature?.isEnabled),
    onSuccess: (data) => {
      queryClient.setQueryData([QueryClientScope.CustomerSetting, data.key], data);
    },
    retry: false,
  });
};
